import {gsap} from 'gsap';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

export const scrollTo = () => {
  const targets = document.querySelectorAll('a[href^="#"]');
  targets.forEach((target) => {
    target.addEventListener('click', (e) => {
      e.preventDefault();
      const anchor = target as HTMLAnchorElement;
      gsap.to(window, {scrollTo: {y: anchor.hash, offsetY: 80}});
    });
  });
};
